<template>
  <section v-if="pax && pax['covid19_portal'] && pax['covid19_portal']['1']">
    <Title
      :title-name="title.ShareUpdate ? title.ShareUpdate.titleName : ''"
      :title-link="title.ShareUpdate ? title.ShareUpdate.titleLink : ''"
      name-page="ShareUpdate"
    />
    <div class="share-des">
      <p class="container">{{ pax.covid19_portal['1'].TITLE_SHARE_UPDATE }}</p>
    </div>
    <div v-if="checkToken && lang && lang['virtual_helpdesk'] && airline">
      <div class="container">
        <div class="share-update" style="margin: 14pt 0">
          <Confirm
            :contacts="contacts"
            @removeContact="removeContact"
            @addContact="addContact"
            @shareUpdate="shareUpdate"
            @onInput="onInput"
          ></Confirm>
        </div>
      </div>
    </div>
    <div v-if="!checkToken">
      <div class="container">
        <h4 style="color: red">{{ pax['covid19_portal'][1].INVALID_TOKEN }}</h4>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/ShareUpdate.scss'
import Title from '@/components/Title/index'
import Confirm from '@/views/ShareUpdate/contactConfirm'

export default {
  name: 'ShareFlight',
  components: { Title, Confirm },
  props: {},
  data() {
    return {
      checkToken: true,
      lang_code: 'en',
      secret: this.$parent.secret,
      contacts: []
    }
  },
  watch: {},
  beforeCreate: function () {
    this.$emit('changeLinkName', '')
  },
  created() {
    this.getContactList()
  },
  methods: {
    getContactList: function () {
      let self = this
      self.$store.dispatch('ShareUpdate/getShareContact', { secret: self.secret }).then((response) => {
        if (response && response.success) {
          self.contacts = response.data
          if (!this.contacts.length) {
            this.contacts.push({ phone_number: '', id: '' })
          }
        }
      })
    },
    removeContact: function (k) {
      if (this.contacts[k].id) {
        this.$store.dispatch('ShareUpdate/deleteShareContact', { secret: this.secret, contact_id: this.contacts[k].id })
      }
      this.contacts = _.without(this.contacts, this.contacts[k])
      if (!this.contacts.length) {
        this.contacts.push({ phone_number: '', id: '' })
      }
    },
    addContact: function (k) {
      if (this.contacts.length < 5) {
        this.contacts.push({ phone_number: '', id: '' })
      }
    },
    shareUpdate: function () {
      let self = this
      let validate = true
      let phones = []
      let phoneDuplicate = false

      _.each(self.contacts, function (item) {
        if (!item.id && item.phone_number) {
          if (!item.isValid) {
            validate = false
          }
        }
        if (!item.phone_number) {
          self.contacts = _.without(self.contacts, item)
        }
        if (phones.includes(item.phone_number)) {
          phoneDuplicate = true
        }
        phones.push(item.phone_number)
      })

      let phoneList = self.contacts
      let msgError = ''
      let msgSuccess = ''
      let buttonOk = self.pax['covid19_portal'][1].CONFIRM_TEXT ? self.pax['covid19_portal'][1].CONFIRM_TEXT : 'Ok'

      if (phoneList.length === 0) {
        msgError = self.pax['covid19_portal'][1].PHONE_REQUIRED ? self.pax['covid19_portal'][1].PHONE_REQUIRED : ''
        this.$swal({ title: msgError, confirmButtonText: buttonOk })
        return
      }

      if (!validate) {
        msgError = self.pax['covid19_portal'][1].PHONE_CHECK ? self.pax['covid19_portal'][1].PHONE_CHECK : ''
        this.$swal({ title: msgError, confirmButtonText: buttonOk })
        return
      }

      // Check duplicate phone
      if (phoneDuplicate) {
        msgError = self.pax['covid19_portal'][1].PHONE_DUPPLICATE ? self.pax['covid19_portal'][1].PHONE_DUPPLICATE : ''
        this.$swal({ title: msgError, confirmButtonText: buttonOk })
        return
      }

      let message = self.pax.covid19_portal['1'].SHARE_UPDATE_MESSAGE_CONTENT
      message = message.replace('<name>', self.pax.full_name).replace('<gender>', self.pax.gender == 'MALE' ? 'he' : 'she')
      self.$store
        .dispatch('ShareUpdate/shareUpdate', { secret: self.secret, contact_list: phoneList, message: message })
        .then((response) => {
          if (response && response.success) {
            msgSuccess = self.pax['covid19_portal'][1].SHARE_SUCCESS ? self.pax['covid19_portal'][1].SHARE_SUCCESS : ''
            this.$swal({ title: msgSuccess, confirmButtonText: buttonOk })
          }
          self.getContactList()
        })
    },
    onInput: function (number, isValid, country, key) {
      if (number == '00' || number == '+00') {
        this.contacts[key].phone_number = '+'
      } else if (number.international) {
        this.contacts[key].phone_number = number.international
      }
      this.contacts[key].isValid = isValid
    }
  }
}
</script>
